import { useEffect, useState } from 'react'
import { useNavigate } from "@shopify/hydrogen/client"
import { CustomerAccount, MenuItem, ShopMetafields } from '~/types'
import { useDrawer } from '../Drawer.client'
import { header } from '../../../../setup/settings/index'
import { showDropDownCustomerAccounts } from '../../../../setup/settings/__product'

type HeaderProps = {
    shop: ShopMetafields
}

export default function useHeader({ shop }: HeaderProps) {
    const [showCategory, setShowCategory] = useState<string | boolean>('');
    const [stickyMenu, setStickyMenu] = useState<boolean>(header.viewSticky);

    const nav = useNavigate();
    const menuItems: MenuItem[] = shop.menuItem?.value != null ? JSON.parse(shop.menuItem?.value) : [];
    const shopSettings = shop.settings?.value != null ? JSON.parse(shop.settings?.value) : JSON.parse('{}');
    const customerAccounts: CustomerAccount[] = showDropDownCustomerAccounts.visible && shop.customers?.value != null ? JSON.parse(shop.customers?.value) : [];

    const goTo = (path: string) => {
        nav(path)
    }

    const {
        isOpen: isCartOpen,
        openDrawer: openCart,
        closeDrawer: closeCart,
    } = useDrawer();

    const {
        isOpen: isMenuOpen,
        openDrawer: openMenu,
        closeDrawer: closeMenu,
    } = useDrawer();

    useEffect(() => {
        if (stickyMenu) {
            updateWidth()
        }
    }, [])

    const updateWidth = () => {
        var contentMain = document.getElementById('mainContent')
        var valueHeader = document.getElementById('headerContent').clientHeight
        contentMain.style.top = valueHeader + "px";
        setStickyMenu(false)
    }

    return {
        isCartOpen,
        closeCart,
        setShowCategory,
        goTo,
        openCart,
        showCategory,
        menuItems,
        shopSettings,
        openMenu,
        isMenuOpen,
        customerAccounts,
        closeMenu
    }
}
